import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, NgForm, FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbCollapse, NgbHighlight, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ProtuneApiService } from '../../services/protune-api.service';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { UserPreferences } from '../../models/user-preferences';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { CommonModule } from '@angular/common';
import { Chart } from 'chart.js/auto';
import { ChartJsDirective } from '../../directives/chart-js.directive';
import { ChartService } from '../../services/chart.service';
import { AnalyzedImageData } from '../../models/analyzed-image-data';
import { Vehicle } from '../../models/vehicle';
import { VehicleSelectorComponent } from '../vehicle-selector/vehicle-selector.component';
import { ImageSelectorComponent } from '../image-selector/image-selector.component';
import { ProcessImageResult } from '../../models/process-image-result';
import { LengthUnits } from '../../models/length-units';
import { LbftTorquePipe } from '../../pipes/lbft-to-torque.pipe';
import { IUnit } from '../../interfaces/unit';
import { HpToPowerPipe } from '../../pipes/hp-to-power.pipe';
import { ImageAnalyzerComponent } from '../image-analyzer-tour/image-analyzer-tour.component';

@Component({
  selector: 'app-process-image-modal',
  standalone: true,
  imports: [CommonModule, NgbTooltip, NgbHighlight, NgbCollapse, FormsModule,
    ReactiveFormsModule, ChartJsDirective, VehicleSelectorComponent,
    ImageSelectorComponent, LbftTorquePipe, HpToPowerPipe,
    ImageAnalyzerComponent],
  templateUrl: './process-image-modal.component.html',
  styleUrl: './process-image-modal.component.scss'
})
export class ProcessImageModalComponent {

  //@ViewChild('screenshot1Selector') file1Uploader: ElementRef;
  //@ViewChild('screenshot2Selector') file2Uploader: ElementRef;
  //@ViewChild('screenshot3Selector') file3Uploader: ElementRef;
  @ViewChild('analyzedDataForm', { static: true }) analyzedDataForm!: NgForm;

  vehicle: Vehicle;
  vehicles: Array<Vehicle>;
  userPreferences: UserPreferences;
  screenshot1File: File;
  screenshot1Filename: string;
  screenshot1DataUrl: string | ArrayBuffer;
  screenshot2File: File;
  screenshot2Filename: string;
  screenshot2DataUrl: string | ArrayBuffer;
  screenshot3File: File;
  screenshot3Filename: string;
  screenshot3DataUrl: string | ArrayBuffer;
  analyzedData: AnalyzedImageData;
  dynoChart: Chart;
  dynoChartConfig: any;
  showResults: boolean;
  loading: boolean;
  howToScreenshotCollapsed: boolean = true;
  howToSelectCollapsed: boolean = true;
  acceptParameters: boolean = true;
  acceptEngineData: boolean = true;
  torqueUnits: IUnit;
  powerUnits: IUnit;

  get analyzedDataFormControl() {
    return this.analyzedDataForm.controls;
  }

  constructor(private activeModal: NgbActiveModal, private protuneApiService: ProtuneApiService,
    private userPreferencesService: UserPreferencesService, private errorHandler: ErrorHandlerService,
    private chartService: ChartService) { }

  ngOnInit(): void {
    this.analyzedData = new AnalyzedImageData();

    this.userPreferencesService.getUserPreferences()
      .subscribe({
        next: (preferences) => {
          this.userPreferences = preferences;
          this.torqueUnits = this.userPreferences.torqueUnits;
          this.powerUnits = this.userPreferences.powerUnits;

        }, error: err => this.errorHandler.handleError('Failed to analyze image.', err.error, err.req, true)
      });

    this.protuneApiService.getAllVehicles()
      .subscribe({
        next: vehicles => this.vehicles = vehicles.sort((a, b) => {
          return a.manufacturer.localeCompare(b.manufacturer);
        }),
        error: err => this.errorHandler.handleError('Unable to get vehicle list.', err.error, err.req, true)
      });
  }

  ok() {

    var results: ProcessImageResult = {
      analyzedImageData: this.analyzedData,
      acceptEngineData: this.acceptEngineData,
      acceptParameters: this.acceptParameters
    };

    this.activeModal.close(results);
  }

  close() {
    this.activeModal.dismiss();
  }

  analyzeImages() {
    this.loading = true;
    this.analyzedData = new AnalyzedImageData();
    this.showResults = false;
    this.dynoChartConfig = null;

    this.protuneApiService
      .getParametersFromImage(this.userPreferences.torqueUnits, this.screenshot1File, this.screenshot2File, this.screenshot3File)
      .subscribe({
        next: analyzedImageData => {
          this.analyzedData = analyzedImageData;
          this.analyzedData.wheelSize = this.userPreferences.lengthUnits == LengthUnits.inch
            ? this.analyzedData.wheelSize
            : LengthUnits.convertInchesToMm(this.analyzedData.wheelSize);

          this.vehicle = this.vehicles.filter(v => v.id == this.analyzedData.vehicleId)[0];
          this.acceptParameters = true;

          if (this.analyzedData.engineData != null) {
            this.createChart();
            this.acceptEngineData = true;
          }

          this.showResults = true;
          this.loading = false;
        },
        error: err => {
          console.log(err);
          this.loading = false;
        }
      });
  }

  
  createChart() {
    if (this.dynoChart != null) {
      this.dynoChart.destroy();
    }

    this.dynoChartConfig = this.chartService
      .createDynoChartConfig(
        this.analyzedData.engineData,
        this.analyzedData.minRPM,
        this.analyzedData.maxRPM,
        this.userPreferences.torqueUnits,
        this.userPreferences.powerUnits);
  }

}

